module.exports = __webpack_public_path__ + "static/media/3129 Echo-Parc_DSCN5725.b637d9a7.jpg";